import React from "react";
import { useNavigate } from "react-router-dom";

export function LegalFooter({ className = "" }) {
  const navigate = useNavigate();
  return (
    <footer className={`border-t border-slate-900 py-6 text-center text-white ${className}`}>
      <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm mb-2">
        <button data-testid="footer-privacy-link" onClick={() => navigate("/privacy")} className="text-white hover:text-blue-400 transition-colors">Privacy Policy</button>
        <span className="text-slate-700">·</span>
        <button data-testid="footer-cookies-link" onClick={() => navigate("/cookies")} className="text-white hover:text-blue-400 transition-colors">Cookies</button>
        <span className="text-slate-700">·</span>
        <button data-testid="footer-terms-link" onClick={() => navigate("/terms")} className="text-white hover:text-blue-400 transition-colors">Terms &amp; Conditions</button>
        <span className="text-slate-700">·</span>
        <a data-testid="footer-support-link" href="mailto:support@rightpay.com?subject=RightPay%20Support%20Request" className="text-white hover:text-blue-400 transition-colors">Contact Support</a>
      </div>
      <p className="text-sm text-white">© {new Date().getFullYear()} Copyright — RightPay is a division of Encore Business Services Group, LLC</p>
    </footer>
  );
}
